/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import {
  fromCents, getCreditInfoMaturityKeys, getCurrencyCode, getInvoicingMaturityKeys,
} from 'utils/helpers';
import CreditInformationItem from 'components/Credit24/SelfService/CreditInformation/CreditInformationItem';

const propTypes = {
  data: PropTypes.object,
};

const CreditInformation = (props) => {
  const { data, data: { creditApplication = {}, id: contractId } } = props;
  const { product = {} } = creditApplication;

  if (isEmpty(data) || isEmpty(product)) {
    return (
      <span />
    );
  }
  let creditInfoPaymentTitle = 'selfservice.creditInformation.mmp';
  const isIL = product.type === 'INSTALLMENT';
  const auIlOnlyItems = [];
  const clOnlyItems = [];
  const creditInformationItems = [];
  const serviceItem = [];
  if (COUNTRY === 'AU') {
    creditInfoPaymentTitle = getCreditInfoMaturityKeys(product.maturityPeriodLength);
    if (isIL) {
      auIlOnlyItems.push(
        {
          id: 'terminationDate',
          value: data.lastDueDate
            ? moment(data.lastDueDate).format('D MMMM YYYY')
            : null,
          style: 'string',
        },
        {
          id: 'establishmentFee',
          value: fromCents(product.openingFee),
          style: 'currency_int',
        }
      );
      // Checking if it is MACC loan
      if (product.principal > 200000) {
        auIlOnlyItems.push(
          {
            id: 'annualInterest',
            value: product.annualInterest,
            style: 'percent',
          },
          {
            id: 'anualPercentageRate',
            value: product.apr,
            style: 'percent',
          }
        );
      }
    } else {
      clOnlyItems.push(
        {
          id: 'totalBalance',
          value: fromCents(data.outstanding),
          isTitleTooltip: true,
        },
        {
          id: 'annualInterest',
          value: product.annualInterest,
          style: 'percent',
        },
        {
          id: 'drawFeeAmountCL',
          value: fromCents(product.withdrawalFixedFee),
          style: 'currency_int',
          currency: getCurrencyCode(),
        },
        {
          id: 'anualPercentageRate',
          value: product.apr,
          style: 'percent',
        }
      );
    }

    if (product.invoicingFee > 0) {
      serviceItem.push({
        id: getInvoicingMaturityKeys(product.maturityPeriodLength),
        value: fromCents(product.invoicingFee),
      });
    }

    creditInformationItems.push(
      ...clOnlyItems,
      ...auIlOnlyItems,
      ...serviceItem
    );
  }

  return (
    <div className="credit-info">
      <div className="credit-info__item credit-info__item--main">
        {isIL ? (
          <FormattedMessage id={`selfservice.creditInformation.repayment.${product.maturityPeriodLength}`} />
        ) : (
          <FormattedMessage id={creditInfoPaymentTitle} />
        )}
        <div className="credit-info__item-value">
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            value={fromCents(data.mmp)}
          />
        </div>
      </div>
      {creditInformationItems.map(({ id, ...rest }) => (
        <CreditInformationItem key={id} id={id} {...rest} />
      ))}
      {isIL && (
        <div className="credit-info__contract-link">
          <a href={`${API_HOST}/contracts/${contractId}/document`} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="selfservice.creditinformation.downloadIlContractLink" />
          </a>
        </div>
      )}
    </div>
  );
};

CreditInformation.propTypes = propTypes;

export default CreditInformation;
